<template>
  <div>
    <base-title-bar-scroll-page
      ref="container"
      :back="true"
      :show-title-bar="showTitleBar"
      back-text="主页"
      title="脊柱侧弯服务支付"
      @onBackClick="onBackClick"
    >
      <div
        v-if="hospital"
        style="margin: 16px; background-color: white; border-radius: 16px; padding-top: 16px"
      >
        <div v-if="envStatus">{{ envStatus }}</div>
        <div style="font-weight: bold; font-size: 20px; text-align: center">
          脊柱侧弯服务支付
        </div>
        <div style="font-size: 14px; text-align: center; margin-bottom: 16px">
          {{ hospital.name }}
        </div>
        <div class="divider"></div>

        <div class="service-images">
          <my-img
            :url="serviceDescUrls[0]"
            class="service-image"
          />
          <div class="detail-toggle" @click="showServiceDetail = !showServiceDetail">
            <span>{{ showServiceDetail ? '收起详情' : '查看详情' }}</span>
            <span :class="['detail-arrow', showServiceDetail ? 'arrow-up' : 'arrow-down']"></span>
          </div>
          <my-img
            v-if="showServiceDetail"
            :url="serviceDescUrls[1]"
            class="service-image detail-image"
          />
        </div>

        <div class="order-panel">
          <section class="form-section">
            <div class="section-title required">服务套餐选择</div>
            <div class="package-card-list">
              <div
                v-for="item in servicePackages"
                :key="item.id"
                :class="['package-card', { active: selectedPackageId === item.id }]"
                @click="selectedPackageId = item.id"
              >
                <div class="package-check">
                  <van-icon v-if="selectedPackageId === item.id" name="success" />
                </div>
                <div class="package-main">
                  <div class="package-name">{{ item.name }}</div>
                  <div class="package-desc">{{ item.period }}</div>
                  <div v-if="item.deposit" class="package-deposit">含一次性押金 ¥{{ item.deposit }}</div>
                </div>
                <div class="package-price">
                  <span class="price-symbol">¥</span>{{ item.price }}
                </div>
              </div>
            </div>
            <div class="quantity-row">
              <div>
                <div class="quantity-title">数量</div>
                <div class="quantity-desc">每份为 {{ selectedPackage.period }}</div>
              </div>
              <van-stepper v-model="packageCount" integer min="1" />
            </div>
          </section>

          <section class="summary-card">
            <div class="summary-head">
              <div>
                <div class="section-title">费用明细</div>
                <div class="summary-subtitle">已选择 {{ selectedPackage.name }}</div>
              </div>
              <div class="summary-total">¥{{ totalPrice }}</div>
            </div>
            <div class="summary-row">
              <span>服务项目</span>
              <strong>脊柱侧弯服务</strong>
            </div>
            <div class="summary-row">
              <span>服务套餐</span>
              <strong>{{ selectedPackage.name }}</strong>
            </div>
            <div class="summary-row">
              <span>服务周期</span>
              <strong>{{ selectedPackage.period }}</strong>
            </div>
            <div class="summary-row">
              <span>数量</span>
              <strong>{{ packageCount }}份</strong>
            </div>
            <div class="summary-row">
              <span>服务费</span>
              <strong>¥{{ selectedPackage.price * packageCount }}</strong>
            </div>
            <div v-if="packageDeposit" class="summary-row">
              <span>押金</span>
              <strong>¥{{ packageDeposit }}</strong>
            </div>
          </section>

          <section class="form-section">
            <div class="section-title required">科室</div>
            <div class="department-chip-list">
              <div
                v-for="department in visibleDepartments"
                :key="department.id"
                :class="['select-chip', { active: selectedDepartment && selectedDepartment.id === department.id }]"
                @click="selectDepartment(department)"
              >
                {{ department.name }}
              </div>
            </div>
          </section>

          <section v-if="selectedDepartment" class="form-section">
            <div class="section-title required">服务管理医生/治疗师</div>
            <div class="doctor-chip-list">
              <div
                v-for="doctor in selectedDepartment.doctors"
                :key="doctor"
                :class="['select-chip', { active: selectedDoctor === doctor }]"
                @click="selectedDoctor = doctor"
              >
                {{ doctor }}
              </div>
            </div>
          </section>

          <section class="patient-card">
            <div class="section-title">患者信息</div>
            <van-field
              v-model="patientName"
              class="patient-field"
              label="姓名"
              placeholder="请输入姓名"
              required
              type="text"
            />
            <van-field
              v-model="patientMobile"
              class="patient-field"
              label="手机号"
              placeholder="请输入手机号"
              required
              type="tel"
            />
          </section>

          <div class="pay-footer">
            <van-button
              class="pay-button"
              round
              type="info"
              @click="submitPayment"
            >立即支付 ¥{{ totalPrice }}
            </van-button>
          </div>
        </div>
      </div>

      <div v-else class="unsupported-card">
        <div class="unsupported-title">暂不支持该医院</div>
        <div class="unsupported-desc">请确认链接中的 hospital_id 是否为 16 或 2。</div>
      </div>

      <div style="text-align: center; font-size: 14px; color: #494949">
        技术支持：动优远程康复服务云平台
      </div>
    </base-title-bar-scroll-page>

    <van-popup
      v-model="showPopup"
      :close-on-click-overlay="false"
      class="popup-wrapper"
      position="bottom"
    >
      <div style="padding: 16px; text-align: center">
        <img
          alt="Success Logo"
          class="success-logo"
          src="https://cdn.keihong.tech/img/202312211813200.png"
        />
        <div class="success-message">支付成功</div>
        <div style="text-align: center; font-size: 14px; margin: 20px 0">
          订单编号：{{ outTradeNo }}
        </div>
        <div style="text-align: center; font-size: 14px; margin: 20px 0">
          {{ orderCreateTime }}
        </div>
        <div style="text-align: center; font-size: 18px; margin: 20px 0">
          脊柱侧弯服务
        </div>
        <div style="font-size: 14px; margin: 20px 0; text-align: left">
          {{ remark }}
        </div>
        <div style="color: red; font-size: 20px; font-weight: bold">
          请截图当前页面
        </div>
        <div style="color: #272727; text-align: left; font-size: 18px">
          请截图当前页面，服务人员将联系您安排脊柱侧弯居家训练服务，请保持手机畅通。如有疑问请联系康复助理了解详情。
        </div>
        <van-button
          style="width: 100%; margin-top: 16px"
          type="primary"
          @click="refreshPage"
        >确定
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'
import { Dialog, Toast } from 'vant'
import WxPayDao from '@/h5/doucan/network/WxPayDao'
import wx from 'weixin-jsapi'
import axios from 'axios'
import DateUtils from '@/utils/DateUtils'
import MyImg from '@/h5/doucan/components/MyImg.vue'

export default {
  name: 'QuickPayScoliosisPage',
  components: {
    MyImg,
    BaseTitleBarScrollPage
  },
  data () {
    return {
      envStatus: '',
      from: '',
      showTitleBar: true,
      showPopup: false,
      hospital: null,
      hospitalId: null,
      patientName: '',
      patientMobile: '',
      testMobile: ['18008000808', '13610164743', '18520535303', '18501011010'],
      openId: '',
      payStatus: false,
      appsecret: '',
      appid: '',
      code: '',
      openid: '',
      paySignInfo: null,
      outTradeNo: '',
      remark: '',
      hospitals: {
        16: {
          name: '广州中医药大学顺德医院',
          departments: [
            {
              id: 1,
              name: '康复医学科',
              doctors: [
                '王文献',
                '盘庆东',
                '梁蔚莉',
                '李文纯',
                '曾文璧',
                '麦淑妍',
                '翁捷涛',
                '潘志明',
                '陈竞豪',
                '范伟棋',
                '钟景涛'
              ]
            }
          ]
        },
        2: {
          name: '暨南大学附属顺德医院',
          departments: [
            {
              id: 1,
              name: '康复医学科',
              doctors: [
                '尹德铭',
                '何志坚',
                '胡旭慧',
                '方向延',
                '李志强',
                '朱智文',
                '潘冠佳',
                '毕娟',
                '赵建华',
                '王悦',
                '邓恩情',
                '冯宗勤',
                '何凤意',
                '李广源',
                '朱墨飞'
              ]
            },
            {
              id: 2,
              name: '骨一科|创伤骨科',
              doctors: [
                '吴春辉',
                '黎凌云',
                '陈小磊',
                '谢伟健',
                '唐迎春',
                '李康',
                '杨勇',
                '郑鸿坚',
                '段礼良',
                '麦绍声',
                '张力予',
                '余君',
                '李洁云',
                '谭丹',
                '陈斯欣',
                '成彩芬',
                '伍翠仪',
                '谷珍荣',
                '黄楚晏',
                '肖楚涵',
                '文区'
              ]
            },
            {
              id: 3,
              name: '骨二科|脊柱外科',
              doctors: [
                '宋兴华',
                '查丁胜',
                '徐自强',
                '蔡跃波',
                '姚华灿',
                '陈计稳',
                '蔡社兴',
                '李笑芬',
                '杨丽',
                '曹辉',
                '李翠莲',
                '吴桂荣',
                '梁春梅',
                '李文军',
                '陈俊杰',
                '叶自由',
                '李梦婷',
                '周悦虹',
                '周坤兰'
              ]
            },
            {
              id: 4,
              name: '神经外科',
              doctors: [
                '王晓东',
                '吴烁龙',
                '潘珏恒',
                '郑颖锋',
                '马劲翔',
                '梁金凤',
                '梁敏仪',
                '陈祝娇',
                '陈秋婷',
                '张翠媚',
                '韩君梅',
                '赵雅丽',
                '袁玉霞',
                '沈燕雯',
                '苏彩霞',
                '魏雪聪',
                '陈若茵'
              ]
            },
            {
              id: 5,
              name: '神经内科',
              doctors: [
                '黄立安',
                '毕伟',
                '乔宏宇',
                '朱慧丽',
                '董大伟',
                '何深文',
                '贺丽萍',
                '杨丽',
                '宋雪珠',
                '吴玉莹',
                '陈怡',
                '樊月映',
                '王艳军',
                '李晓莹',
                '陈欢',
                '吴静文',
                '胡嘉媚',
                '黄燕芳',
                '吴祥雄',
                '唐耀',
                '杨延丽',
                '柯世琴',
                '张小红',
                '曾翠娟',
                '罗三妹',
                '黄文萍',
                '陈敏',
                '梁慧诗'
              ]
            }
          ]
        }
      },
      serviceDescUrls: [
        'https://cdn.keihong.tech/20260522220913049.png',
        'https://cdn.keihong.tech/20260522172245716.jpg'
      ],
      servicePackages: [
        {
          id: 'hardware_plus',
          name: '智能硬件加强版',
          period: '30天服务包',
          price: 980,
          deposit: 1000
        },
        {
          id: 'mini_program_basic',
          name: '小程序基础版',
          period: '30天服务包',
          price: 580,
          deposit: 0
        }
      ],
      packageTypeMap: {
        hardware: 'hardware_plus',
        basic: 'mini_program_basic'
      },
      selectedPackageId: 'hardware_plus',
      packageCount: 1,
      showServiceDetail: false,
      selectedDepartment: null,
      selectedDoctor: null,
      orderCreateTime: null
    }
  },
  computed: {
    selectedPackage () {
      return this.servicePackages.find(item => item.id === this.selectedPackageId) || this.servicePackages[0]
    },
    packageDeposit () {
      return this.selectedPackage.deposit || 0
    },
    totalPrice () {
      return this.selectedPackage.price * this.packageCount + this.packageDeposit
    },
    visibleDepartments () {
      if (!this.hospital) {
        return []
      }
      return this.hospital.departments.filter(department => department.name === '康复医学科')
    }
  },
  mounted () {
    this.hospitalId = parseInt(this.$route.query.hospital_id)
    this.hospital = this.hospitals[this.hospitalId] || null

    const packageType = this.$route.query.package_type
    if (this.packageTypeMap[packageType]) {
      this.selectedPackageId = this.packageTypeMap[packageType]
    }

    const phone = this.$route.query.phone
    const name = this.$route.query.name
    const openid = this.$route.query.openid
    this.from = this.$route.query.from

    if (this.visibleDepartments.length === 1) {
      this.selectedDepartment = this.visibleDepartments[0]
      if (this.selectedDepartment.doctors.length === 1) {
        this.selectedDoctor = this.selectedDepartment.doctors[0]
      }
    }

    this.$refs.container.stopLoading()

    const isWeChatBrowser = () => {
      const userAgent = navigator.userAgent.toLowerCase()
      return userAgent.includes('micromessenger')
    }

    if (this.from === 'wxapp') {
      this.showTitleBar = false
      this.patientMobile = phone
      this.patientName = name
      this.openid = openid
    } else if (isWeChatBrowser()) {
      this.initWx()
    }
  },
  methods: {
    onBackClick () {
      if (!this.hospital) {
        window.location.href = 'https://doucan.jianerkanggz.cn/#/home/square'
        return
      }
      window.location.href =
        'https://doucan.jianerkanggz.cn/#/home/square?hospital=' +
        this.hospital.name
    },
    refreshPage () {
      this.showPopup = false
      if (this.from !== 'wxapp') {
        this.onBackClick()
      }
    },
    submitPayment () {
      this.pay()
    },
    async initWx () {
      await this.getAppid()
      const openid = this.$store.state.user.openId
      if (openid) {
        this.openid = openid
      } else {
        await this.getMpOpenID()
      }
    },
    async pay () {
      if (!this.hospital) {
        this.$toast({
          type: 'fail',
          message: '暂不支持该医院',
          duration: 2000
        })
        return
      }

      if (!this.selectedPackageId) {
        this.$toast({
          type: 'fail',
          message: '请选择服务套餐',
          duration: 2000
        })
        return
      }

      if (!this.selectedDepartment) {
        this.$toast({
          type: 'fail',
          message: '请选择科室',
          duration: 2000
        })
        return
      }

      if (!this.selectedDoctor) {
        this.$toast({
          type: 'fail',
          message: '请选择医生',
          duration: 2000
        })
        return
      }

      if (!this.patientName || !this.patientMobile) {
        this.$toast({
          type: 'fail',
          message: '请填写姓名和手机号',
          duration: 2000
        })
        return
      }

      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })

      const fee = this.testMobile.includes(this.patientMobile) ? 0.01 : this.totalPrice
      const depositText = this.packageDeposit ? `-押金:${this.packageDeposit}元` : ''
      const goods = `${this.hospital.name}-脊柱侧弯服务-${this.selectedPackage.name}-${this.selectedPackage.period}x${this.packageCount}${depositText}-医:${this.selectedDoctor}-患:${this.patientName}`
      this.remark = `脊柱侧弯服务-${this.selectedPackage.name}-${this.selectedPackage.period}x${this.packageCount}${depositText}-${this.hospital.name}-${this.selectedDepartment.name}-${this.selectedDoctor}-${this.patientName}-${this.patientMobile}`

      const profile = {
        serveType: 0,
        mobile: this.patientMobile,
        patientName: this.patientName,
        patientMobile: this.patientMobile,
        orderType: '',
        fee: fee,
        fromActivity: '扫码直接支付-脊柱侧弯服务',
        goods: goods,
        openId: this.openid,
        doctor: this.selectedDoctor,
        sick: '脊柱侧弯',
        department: this.selectedDepartment.name,
        hospital: this.hospital.name,
        remark: this.remark
      }

      this.orderCreateTime = DateUtils.formateDate(
        new Date(),
        'YYYY-MM-DD HH:mm:ss'
      )
      const data = await WxPayDao.createOrder(profile, this.from === 'wxapp')
      if (data.code === 1) {
        this.paySignInfo = data.data
        this.outTradeNo = data.data.outTradeNo

        if (this.from === 'wxapp') {
          this.paySignInfo.orderInfo = {
            outTradeNo: this.outTradeNo,
            orderCreateTime: this.orderCreateTime,
            remark: this.remark
          }
          const wxJson = JSON.stringify(this.paySignInfo)
          const encodedParam = encodeURIComponent(wxJson)
          window.wx.miniProgram.navigateTo({
            url: `/pages/pay_submit_universe/pay_submit_universe?param=${encodedParam}`
          })
        } else {
          wx.config({
            debug: false,
            appId: this.paySignInfo.sign.appId,
            timestamp: this.paySignInfo.sign.timeStamp,
            nonceStr: this.paySignInfo.sign.nonceStr,
            signature: this.paySignInfo.sign.paySign,
            jsApiList: ['chooseWXPay']
          })
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: ['chooseWXPay'],
              success: function (res) {
                console.log('seccess')
                console.log('hskdjskjk', res)
              },
              fail: function (res) {
                console.log('fail')
                console.log(res)
              }
            })
            const _that = this
            wx.chooseWXPay({
              timestamp: this.paySignInfo.sign.timeStamp,
              nonceStr: this.paySignInfo.sign.nonceStr,
              package: this.paySignInfo.sign.packageValue,
              signType: this.paySignInfo.sign.signType,
              paySign: this.paySignInfo.sign.paySign,
              success: function (res) {
                if (res.errMsg === 'chooseWXPay:ok') {
                  _that.payStatus = true
                  Dialog.alert({
                    message: '支付成功'
                  }).then(() => {
                    _that.showPopup = true
                  })
                } else {
                  Dialog({ message: JSON.stringify(res) })
                  _that.payStatus = false
                }
              },
              fail: function (res) {
                Dialog({ message: '支付失败:' + JSON.stringify(res) })
                _that.payStatus = false
              }
            })
          })
          wx.error((err) => {
            alert(err)
          })
        }
      } else {
        console.log('支付失败-订单创建失败', data)
      }
    },
    async getOpenId (code) {
      const url = '/quick/pay/openid?code=' + code

      axios
        .get(url)
        .then((res) => {
          this.openid = res.data.data.openid
          if (!this.openid) {
            this.getCodeApi()
            return
          }
          this.$store.commit('user/setOpenId', this.openid)
        })
        .catch((err) => {
          console.log('err', err)
          this.getCodeApi()
        })
    },
    getCodeApi () {
      const appid = 'wxcb56667c309e369b'
      const urlNow = encodeURIComponent(window.location.href)
      const scope = 'snsapi_base'
      const url =
        'https://open.weixin.qq.com' +
        '/connect/oauth2/authorize?appid=' +
        appid +
        '&redirect_uri=' +
        urlNow +
        '&response_type=code&scope=' +
        scope +
        '#wechat_redirect'
      window.location.href = url
    },
    getUrlKey (name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [undefined, ''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },
    async getAppid () {
      const url = '/quick/pay/appid'
      const res = await axios.get(url)
      this.appid = res.data.data.codeName
      this.appsecret = res.data.data.codeValue
    },
    async getMpOpenID () {
      const code = this.getUrlKey('code')
      if (code) {
        this.code = code
        await this.getOpenId(code)
      } else {
        this.getCodeApi()
      }
    },
    selectDepartment (department) {
      this.selectedDepartment = department
      this.onDepartmentSelected()
    },
    onDepartmentSelected () {
      this.selectedDoctor = null
      if (this.selectedDepartment && this.selectedDepartment.doctors.length === 1) {
        this.selectedDoctor = this.selectedDepartment.doctors[0]
      }
    }
  }
}
</script>

<style scoped>
.divider {
  height: 1px;
  background-color: #eef2f7;
  margin: 16px;
}

.service-images {
  padding: 0 16px;
}

.service-image {
  display: block;
  width: 100%;
  margin-bottom: 12px;
  border-radius: 10px;
  overflow: hidden;
}

.detail-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px 0 12px;
  padding: 10px 0;
  color: #1989fa;
  font-size: 14px;
  text-align: center;
  background: #f3f8ff;
  border: 1px solid #d5e9ff;
  border-radius: 999px;
}

.detail-arrow {
  width: 8px;
  height: 8px;
  margin-left: 8px;
  border-right: 2px solid #1989fa;
  border-bottom: 2px solid #1989fa;
  transition: transform 0.2s ease;
}

.arrow-down {
  transform: translateY(-2px) rotate(45deg);
}

.arrow-up {
  transform: translateY(2px) rotate(-135deg);
}

.detail-image {
  margin-top: 12px;
}

.order-panel {
  padding: 4px 14px 18px;
}

.form-section,
.summary-card,
.patient-card {
  margin-top: 14px;
  padding: 16px;
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.06);
}

.section-title {
  position: relative;
  margin-bottom: 12px;
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
}

.section-title.required::before {
  content: '*';
  margin-right: 4px;
  color: #ee0a24;
}

.package-card-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.package-card {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 76px;
  padding: 14px 14px 14px 48px;
  background: linear-gradient(135deg, #f8fbff 0%, #ffffff 100%);
  border: 1px solid #e5edf7;
  border-radius: 16px;
  transition: all 0.2s ease;
}

.package-card.active {
  background: linear-gradient(135deg, #edf7ff 0%, #ffffff 100%);
  border-color: #1989fa;
  box-shadow: 0 8px 20px rgba(25, 137, 250, 0.14);
}

.package-check {
  position: absolute;
  left: 14px;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #fff;
  background: #fff;
  border: 1px solid #c8d1dc;
  border-radius: 50%;
  transform: translateY(-50%);
}

.package-card.active .package-check {
  background: #1989fa;
  border-color: #1989fa;
}

.package-main {
  flex: 1;
  min-width: 0;
}

.package-name {
  color: #1f2937;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
}

.package-desc {
  margin-top: 6px;
  color: #6b7280;
  font-size: 13px;
}

.package-deposit {
  display: inline-block;
  margin-top: 8px;
  padding: 3px 8px;
  color: #f59e0b;
  font-size: 12px;
  background: #fff7e6;
  border-radius: 999px;
}

.quantity-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  padding: 14px;
  background: #f8fbff;
  border: 1px solid #e5edf7;
  border-radius: 14px;
}

.quantity-title {
  color: #1f2937;
  font-size: 15px;
  font-weight: 700;
}

.quantity-desc {
  margin-top: 4px;
  color: #8a94a3;
  font-size: 12px;
}

.package-price {
  margin-left: 10px;
  color: #1989fa;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
}

.price-symbol {
  margin-right: 1px;
  font-size: 15px;
  font-weight: 700;
}

.summary-card {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.summary-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #eef2f7;
}

.summary-subtitle {
  color: #8a94a3;
  font-size: 12px;
}

.summary-total {
  color: #1989fa;
  font-size: 24px;
  font-weight: 800;
}

.summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  color: #8a94a3;
  font-size: 14px;
}

.summary-row strong {
  max-width: 62%;
  color: #1f2937;
  font-weight: 600;
  text-align: right;
}

.department-chip-list,
.doctor-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.select-chip {
  padding: 8px 13px;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.2;
  background: #f7f8fa;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
}

.select-chip.active {
  color: #1989fa;
  font-weight: 700;
  background: #eef7ff;
  border-color: #1989fa;
}

.patient-card .section-title {
  margin-bottom: 4px;
}

.patient-field {
  padding: 12px 0 12px 14px;
  border-bottom: 1px solid #f0f2f5;
}

.patient-field::v-deep .van-cell--required::before {
  left: 0;
}

.patient-field::v-deep .van-field__label {
  width: 5.2em;
  margin-right: 10px;
}

.patient-field:last-child {
  border-bottom: 0;
}

.pay-footer {
  display: flex;
  align-items: center;
  margin-top: 16px;
  padding: 12px;
  background: #fff;
  border: 1px solid #eef2f7;
  border-radius: 18px;
  box-shadow: 0 8px 24px rgba(31, 45, 61, 0.08);
}

.pay-button {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(25, 137, 250, 0.22);
}

.popup-wrapper {
  height: 80vh;
}

.success-logo {
  width: 70px;
  height: 70px;
  margin: 0 auto;
}

.success-message {
  text-align: center;
  font-size: 20px;
  margin: 20px 0;
}

.unsupported-card {
  margin: 16px;
  padding: 32px 16px;
  background-color: #fff;
  border-radius: 16px;
  text-align: center;
}

.unsupported-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.unsupported-desc {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}
</style>
